<div class="banner-a2hs-container"  *ngIf="localShowButton  &&  !isInsideWebAppHomeScreen">
  <h3>{{'components.bannerhomescreen.testo'|translate}}</h3>

  <button class="btn btn-primary" mat-raised-button (click)="addToHomeScreenClick()">{{'components.bannerhomescreen.btn_installa'|translate}}</button>
  <button  class="btn "  mat-raised-button (click)="closeA2HS()">{{'components.bannerhomescreen.btn_cancella'|translate}}</button>

</div>
